import config from '@/assets/config.json';
import api from '../../api/index';
const state = {
    userRegist: {}
}
const mutations = {

}
const getters = {

}
const actions = {
    Classification({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/DataAnalysis/GetGoodsType`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    GetCommodityList({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/DataAnalysis/GoodsSalesGetList`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    GetPieChart({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/DataAnalysis/GoodsSalesGetListPieChart`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    GetListExport({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/DataAnalysis/GoodsSalesGetListExport`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    CompaniesRatio({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/DataAnalysis/LogisticsCompaniesRatio`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    ShippingStatistics({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/DataAnalysis/SendOutGoodsList`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    ShippingStatisticsExport({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/DataAnalysis/SendOutGoodsListExport`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },

    InquiryDetails({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/DataAnalysis/GetOrderDetail`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
                
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}